(function () {
  'use strict';

  if (window.gigiFloatingWhatsappReady) return;
  window.gigiFloatingWhatsappReady = true;

  var ON_GREEN_CLASS = 'gigi-floating-whatsapp--on-green';
  var VISIBLE_CLASS = 'gigi-floating-whatsapp--visible';
  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  var VIEWPORT_SHIFT_PROPERTY = '--gigi-floating-whatsapp-viewport-shift';
  var button = null;
  var frame = 0;

  function colorNumber(value) {
    if (!value) return 0;
    if (value.indexOf('%') !== -1) return (parseFloat(value) / 100) * 255;
    return parseFloat(value);
  }

  function alphaNumber(value) {
    if (!value) return 1;
    if (value.indexOf('%') !== -1) return parseFloat(value) / 100;
    return parseFloat(value);
  }

  function colorsFromCss(value) {
    var colors = [];
    if (!value || value === 'transparent' || value === 'none') return colors;

    value.replace(/#([0-9a-f]{3,8})\b|rgba?\(([^)]+)\)/gi, function (match, hex, rgb) {
      if (hex) {
        if (hex.length === 3 || hex.length === 4) {
          colors.push({
            r: parseInt(hex.charAt(0) + hex.charAt(0), 16),
            g: parseInt(hex.charAt(1) + hex.charAt(1), 16),
            b: parseInt(hex.charAt(2) + hex.charAt(2), 16),
            a: hex.length === 4 ? parseInt(hex.charAt(3) + hex.charAt(3), 16) / 255 : 1,
          });
        } else {
          colors.push({
            r: parseInt(hex.slice(0, 2), 16),
            g: parseInt(hex.slice(2, 4), 16),
            b: parseInt(hex.slice(4, 6), 16),
            a: hex.length === 8 ? parseInt(hex.slice(6, 8), 16) / 255 : 1,
          });
        }

        return match;
      }

      var parts = rgb.replace(/\//g, ' ').replace(/,/g, ' ').trim().split(/\s+/);
      colors.push({
        r: colorNumber(parts[0]),
        g: colorNumber(parts[1]),
        b: colorNumber(parts[2]),
        a: alphaNumber(parts[3]),
      });

      return match;
    });

    return colors;
  }

  function looksLikeGigiGreen(color) {
    if (!color || color.a < 0.24) return false;

    return color.g > 150 && color.r > 90 && color.r < 180 && color.b < 90 && color.g - color.r > 30;
  }

  function hasGigiGreen(value) {
    return colorsFromCss(value).some(looksLikeGigiGreen);
  }

  function hasOpaqueBackground(value) {
    return colorsFromCss(value).some(function (color) {
      return color.a >= 0.72;
    });
  }

  function surfaceIsGreen(element) {
    var current = element;

    while (current && current.nodeType === 1) {
      var style = window.getComputedStyle(current);

      if (hasGigiGreen(style.backgroundImage) || hasGigiGreen(style.backgroundColor)) return true;
      if (hasOpaqueBackground(style.backgroundColor)) return false;

      current = current.parentElement;
    }

    return false;
  }

  function elementUnderButton() {
    var rect = button.getBoundingClientRect();
    var viewportWidth = window.visualViewport && MOBILE_QUERY.matches ? window.visualViewport.width : window.innerWidth;
    var viewportHeight = window.visualViewport && MOBILE_QUERY.matches ? window.visualViewport.height : window.innerHeight;
    var x = Math.min(viewportWidth - 1, Math.max(0, rect.left + rect.width / 2));
    var y = Math.min(viewportHeight - 1, Math.max(0, rect.top + rect.height / 2));
    var previousPointerEvents = button.style.pointerEvents;
    var element = null;

    button.style.pointerEvents = 'none';
    element = document.elementFromPoint(x, y);
    button.style.pointerEvents = previousPointerEvents;

    return element;
  }

  function visualViewportShift() {
    if (!window.visualViewport || !MOBILE_QUERY.matches) return 0;

    var layoutHeight = document.documentElement.clientHeight || window.innerHeight;
    var visualBottom = window.visualViewport.offsetTop + window.visualViewport.height;

    return Math.min(0, visualBottom - layoutHeight);
  }

  function updateViewportPosition() {
    if (!button) return;

    var shift = visualViewportShift();
    button.style.setProperty(VIEWPORT_SHIFT_PROPERTY, Math.abs(shift) > 0.5 ? shift.toFixed(2) + 'px' : '0px');
  }

  function scrolledPastHeader() {
    var header = document.querySelector('.section-header');
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (!header) return scrollTop > 0;
    if (header.classList.contains('scrolled-past-header')) return true;

    return scrollTop > header.offsetHeight;
  }

  function updateVisibility() {
    if (!button) return true;

    var isVisible = scrolledPastHeader();
    button.classList.toggle(VISIBLE_CLASS, isVisible);

    return isVisible;
  }

  function updateIconColor() {
    if (!button) return;

    if (
      !MOBILE_QUERY.matches ||
      button.getBoundingClientRect().width === 0 ||
      !button.classList.contains(VISIBLE_CLASS)
    ) {
      button.classList.remove(ON_GREEN_CLASS);
      return;
    }

    button.classList.toggle(ON_GREEN_CLASS, surfaceIsGreen(elementUnderButton()));
  }

  function updateButton() {
    frame = 0;

    updateViewportPosition();
    updateVisibility();
    updateIconColor();
  }

  function requestUpdate() {
    if (frame) return;
    frame = window.requestAnimationFrame(updateButton);
  }

  function init() {
    button = document.querySelector('.gigi-floating-whatsapp');
    if (!button) return;

    updateButton();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('orientationchange', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);

    if (MOBILE_QUERY.addEventListener) {
      MOBILE_QUERY.addEventListener('change', requestUpdate);
    } else if (MOBILE_QUERY.addListener) {
      MOBILE_QUERY.addListener(requestUpdate);
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', requestUpdate);
      window.visualViewport.addEventListener('scroll', requestUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
